import dismissNotification from 'redux/domain/Notifications/actions';
import toJS from 'shared/components/toJS';
import { connect } from 'react-redux';
import { closeCancelConfirmModal, closeExitConfirmModal } from 'redux/domain/App';
import { openSnackbar } from 'redux/domain/Notifications/creators';
import withRouter from '../../shared/utils/WithRouter';
import App from './components/App';

// make state available via props
const mapStateToProps = state => ({
	isCancelConfirmModalOpen: state.app.get('isCancelConfirmModalOpen'),
	isExitConfirmModalOpen: state.app.get('isExitConfirmModalOpen'),
	isSnackbarOpen: state.notifications.get('isSnackbarOpen'),
	notification: state.notifications.get('messages').first(),
	settings: state.cache.get('settings'),
});

// make actions available via props
const mapDispatchToProps = {
	closeCancelConfirmModal,
	closeExitConfirmModal,
	openSnackbar,
	dismissNotification,
};

// generate a route-aware container component
const AppContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(toJS(App)));

export default AppContainer;
export { mapStateToProps, mapDispatchToProps }; // for testing purposes only
